// extracted by mini-css-extract-plugin
export default {"groupField":"GwNKbUyob5S7f7ZDYaB8","balance":"VwkMHcJQCZytJ7ULzNgP","group":"WoArWDwahQPzSc1yVWoz","cell":"J1aqOKTVOmPkVTEGCman","switchButton":"AqE8wMcIIFWf1dH1s3OX"};